import * as moment from "moment-timezone";
import * as _ from "lodash";
import * as qs from 'query-string';
import { Component, FormEvent } from 'react';
import { connect, Dispatch } from "react-redux";
import MediaQuery from "react-responsive";
import { Glyphicon, FormControl, ToggleButtonGroup, ToggleButton, InputGroup } from "react-bootstrap";
import { AppActionCreators, SwapActionCreators, IApplicationState, IAppState, IMoveTrackerListResponse, ILogisticsListResponse, ISwapLookupDataResponse, ISwapState, CenterActionCreators, ContactActionCreators } from "@nkr/store/index";
import { IMoveTracker, IBaseResponse, ILogisticsResponse, ILogistics, IFailSafeAcknowledgeAlert, ILogisticsRequest } from "@nkr/models/index";
import { DisplayType, ActiveLogisticsPlan, CourierLogisticsConfirmationEmailType } from "@nkr/enums/index";
import { IRefreshInterval } from "../models";
import { FormControlWrapper } from "../styles";
import MoveTrackerList from "./move-tracker-list";
import MoveTrackerListCard from "./move-tracker-list-card";
import Logistics from "../swap-list/logistics";
import LogisticsView from "../swap-list/logistics/view";
import AcknowledgeAlert from "./acknowledge-alert";
import MaskedInput from 'react-maskedinput';
import { toast } from "react-toastify";
import { downloadFile } from '@nkr/services/download-file';

const refreshIntervals: IRefreshInterval[] = [
    { value: 0, label: "Disable" },
    { value: 30, label: "30 seconds" },
    { value: 60, label: "60 seconds" },
    { value: 120, label: "2 minutes" },
    { value: 300, label: "5 minutes" }
];

interface IOwnProps {
    reloadCounts: () => void,
    isOps: boolean,
    isCourier: boolean,
    chainId?: string,
    cluster?: string,
    position?: string
}

interface IStateProps {
    app: IAppState,
    swaps: ISwapState
}

interface IDispatchProps {
    toggleLoading: (showLoading?: boolean, message?: string) => void,
    showLoading: (message: string) => Promise<any>,
    hideLoading: () => void,
    getSwapsInProcess: (isOps: boolean) => Promise<IMoveTrackerListResponse>,
    getSwapsForMoveTracker: (isOps: boolean, centerId?: number, clearCache?: number) => Promise<IMoveTrackerListResponse>
    getLogisticsData: (donorId: number, recipientId: number) => Promise<ILogisticsResponse>,
    getLogisticsDataByChainCluster: (chainId: number, clusterNumber: number) => Promise<ILogisticsListResponse>,
    getLookupData: () => Promise<ISwapLookupDataResponse>,
    saveActiveLogisticsPlan: (donorId: number, activeLogisticsPlan: ActiveLogisticsPlan) => Promise<IBaseResponse>,
    saveNotes: (donorId: number, notes: string) => Promise<IBaseResponse>,
    failSafeAcknowledgeAlert: (request: IFailSafeAcknowledgeAlert) => Promise<IBaseResponse>,
    saveLogisticsData: (logistics: ILogisticsRequest) => Promise<IBaseResponse>,
    changeDisplay: (display: number) => void,
    sendCourierEmail: (chainId: number, clusterNumber: number, positionMumber: number, emailType: number) => Promise<IBaseResponse>,
    getCenterAddressesDownload: (donorCenterId: number, recipCenterId: number, clusterId: number) => Promise<any>,
    getCenterContactsDownload: (clusterId: number) => Promise<any>
}

type TProps =
    IOwnProps
    & IStateProps
    & IDispatchProps;

interface IState {
    list: IMoveTracker[],
    autoRefresh: number,
    loading: boolean,
    showSwaps: string,
    displayTimeZone: string,
    startDate: string,
    endDate: string,
    logistics: {
        show: boolean,
        data: ILogistics | null
    },
    logisticsEdit: {
        show: boolean,
        list: ILogistics[],
        data: ILogistics | null,
        clusterId: number
    },
    alert: {
        show: boolean,
        data: IMoveTracker
    }
}

const initialState: IState = {
    list: [],
    autoRefresh: 0,
    loading: true,
    showSwaps: "ALL",
    displayTimeZone: "DONORCENTER",
    startDate: __ENVIRONMENT__ == 'dev' ? '06/07/2021' : moment().day(0).format('MM/DD/YYYY'),
    endDate: moment().day(0).add(2, 'week').format('MM/DD/YYYY'),
    logistics: {
        show: true,
        data: null
    },
    logisticsEdit: {
        show: false,
        list: [],
        data: null,
        clusterId: 0
    },
    alert: {
        show: false,
        data: null
    }
};

class MoveTrackerContainer extends Component<TProps, IState> {
    readonly state: IState = initialState;

    interval: any;

    componentDidMount = () => {
        let parsed = qs.parse(window.location.search);
        let displayTimeZone = parsed.tz ? parsed.tz : this.state.displayTimeZone;
        let showSwaps = parsed.swaps ? parsed.swaps : 'ALL';
        let show = parsed.show ? parseInt(parsed.show) : this.props.app.display;
        let autoRefresh = parsed.refresh ? parseInt(parsed.refresh) : 0;

        if (show == 0) {
            show = 1;
        }

        this.props.changeDisplay(show);

        this.setState({
            showSwaps,
            displayTimeZone,
            autoRefresh
        }, () => {
            this.getData(false);
        });

        if (this.state.autoRefresh > 0)
            this.interval = setInterval(() => this.refresh(), 3000);
    }

    componentWillUnmount = () => {
        if (this.state.autoRefresh == 0) {
            clearInterval(this.interval);
        }
    }

    getAllSwaps = (clearCache: boolean) => {
        return this.props.getSwapsForMoveTracker(this.props.isOps, null, clearCache ? 1 : 0).then((response: IMoveTrackerListResponse) => {
            let swap: IMoveTracker = null;

            if (this.props.chainId && this.props.cluster && this.props.position) {
                swap = response.data.results.find(x => x.chainId == parseInt(this.props.chainId) && x.clusterNumber == parseInt(this.props.cluster) && x.positionNumber == parseInt(this.props.position) && x.activeAlert);
            }

            this.setState({
                list: response.data.results,
                loading: false,
                alert: {
                    show: swap ? true : false,
                    data: swap ? _.cloneDeep(swap) : null
                }
            }, () => {
                return Promise.resolve();
            });
        });
    }

    getTodaySwaps = () => {
        return this.props.getSwapsInProcess(this.props.isOps).then((response: IMoveTrackerListResponse) => {
            let swap: IMoveTracker = null;

            if (this.props.chainId && this.props.cluster && this.props.position) {
                swap = response.data.results.find(x => x.chainId == parseInt(this.props.chainId) && x.clusterNumber == parseInt(this.props.cluster) && x.positionNumber == parseInt(this.props.position) && x.activeAlert);
            }

            this.setState({
                list: response.data.results,
                loading: false,
                alert: {
                    show: swap ? true : false,
                    data: swap ? _.cloneDeep(swap) : null
                }
            }, () => {
                return Promise.resolve();
            });
        });
    }

    getData = (isRefresh: boolean) => {
        if (!isRefresh) {
            this.props.getLookupData();
        }

        if (this.state.showSwaps == 'ALL') {
            return this.getAllSwaps(isRefresh);
        } else {
            return this.getTodaySwaps();
        }
    }

    getList = () => {
        let list = _.orderBy(this.state.list.filter(swap => {
            if (this.state.showSwaps == "ALL") {
                let startDate = moment(this.state.startDate, 'MM/DD/YYYY', true);
                let endDate = moment(this.state.endDate, 'MM/DD/YYYY', true);
                let kidneyPickup = moment(swap.kidneyPickup, 'MM/DD/YY HH:mm', true);

                if (startDate.isValid() && endDate.isValid() && kidneyPickup.isValid()) {
                    return kidneyPickup.isSameOrAfter(startDate, 'day') && kidneyPickup.isSameOrBefore(endDate, 'day');
                } else {
                    return false;
                }
            } else {
                return new Date(swap.kidneyPickup) < new Date(new Date().toLocaleDateString() + " 23:59:59");
            }
        }), (item: IMoveTracker) => {
            return new Date(item.kidneyPickupLocal);
        }, ['asc']);

        return list;
    }

    refresh = () => {
        this.setState({
            loading: true
        }, () => {
            if (this.props.isOps == false) {
                this.props.reloadCounts();
            }

            return this.getData(true).then(() => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    handleRefresh = () => {
        this.refresh();
    }

    handleAutoRefreshChange = (e: any) => {
        this.setState({
            autoRefresh: e.target.value
        }, () => {
            clearInterval(this.interval);

            if (this.state.autoRefresh > 0)
                this.interval = setInterval(() => this.refresh(), this.state.autoRefresh * 1000);
        });
    }

    handleShowMap = (url: string) => {
        window.open(url);
    }

    handleShowGps = (url: string) => {
        window.open(url);
    }

    handleSwitchPlan = (item: IMoveTracker) => {
        if (this.props.isCourier == false) {
            if (this.props.isOps == false) {
                this.props.saveActiveLogisticsPlan(item.donorId, item.activeLogisticsPlan == ActiveLogisticsPlan.Primary.toString() ? ActiveLogisticsPlan.Backup : ActiveLogisticsPlan.Primary).then(response => {
                    this.getData(false);
                });
            }
        }
    }

    handleCloseLogistics = () => {
        this.setState({
            logistics: {
                show: false,
                data: null
            }
        });
    }

    handleViewLogistics = (item: IMoveTracker) => {
        if (this.props.isOps == false) {
            this.props.toggleLoading(true, "Fetching logistics information, one moment please...");

            this.props.getLogisticsData(item.donorId, item.recipientId)
                .then(response => {
                    if (response.data.success) {
                        this.setState({
                            logistics: {
                                show: true,
                                data: response.data.results
                            }
                        }, () => {
                            this.props.toggleLoading(false);
                        });
                    }
                });
        }
    }

    handleEditLogistics = (item: IMoveTracker) => {
        let { clusterId, chainId, clusterNumber, positionNumber } = item;

        this.props.showLoading("Fetching logistics information, one moment please...").then(() => {
            this.props.getLogisticsDataByChainCluster(chainId, clusterNumber).then(response => {
                var { success, results } = response.data;

                if (success) {
                    this.setState({
                        logisticsEdit: {
                            show: true,
                            list: results,
                            data: results.find(item => item.position == positionNumber.toString()),
                            clusterId
                        }
                    }, () => {
                        this.props.hideLoading();
                    });
                }
            });
        });
    }

    handleSaveLogistics = (logistics: ILogisticsRequest) => {
        this.props.showLoading("Saving logistics information, one moment please...").then(() => {
            this.props.saveLogisticsData(logistics).then(response => {
                this.props.hideLoading();

                var { success } = response.data;

                if (success) {
                    this.setState({
                        logisticsEdit: {
                            show: false,
                            list: [],
                            data: null,
                            clusterId: 0
                        }
                    }, () => {
                        this.getData(false);
                    });
                }
            });
        });
    }

    handleSaveLogisticsForCourier = (logistics: ILogisticsRequest) => {
        let {
            kidneyPickupDateTimeActual: newPU,
            tenderedToAirlineActual: newTendered,
            flightDepartureTimeActual: newDeparture,
            leg2DepartureTimeActual: newLeg2Departure,
            recoveredFromAirlineActual: newRecovered,
            kidneyArrivalDateTimeActual: newDelivered,
            flightCarrierAndNumberActual,
            chainId,
            clusterNumber,
            position
        } = logistics;

        let {
            kidneyPickupDateTimeActual: oldPU,
            tenderedToAirlineActual: oldTendered,
            flightDepartureTimeActual: oldDeparture,
            leg2DepartureTimeActual: oldLeg2Departure,
            recoveredFromAirlineActual: oldRecovered,
            kidneyArrivalDateTimeActual: oldDelivered
        } = this.state.logisticsEdit.data;

        let doPU = newPU != null && newPU != '' && newPU != oldPU;
        let doTendered = newTendered != null && newTendered != '' && newTendered != oldTendered;
        let doDeparture = newDeparture != null && newDeparture != '' && newDeparture != oldDeparture;
        let doLeg2Departure = newLeg2Departure != null && newLeg2Departure != '' && newLeg2Departure != oldLeg2Departure;
        let doRecovered = newRecovered != null && newRecovered != '' && newRecovered != oldRecovered;
        let doDelivered = newDelivered != null && newDelivered != '' && newDelivered != oldDelivered;

        let emailType: CourierLogisticsConfirmationEmailType = CourierLogisticsConfirmationEmailType.Unknown;

        if (doPU) {
            emailType = CourierLogisticsConfirmationEmailType.PickupConfirmation;
        }

        if (doTendered) {
            emailType = CourierLogisticsConfirmationEmailType.TenderedConfirmation;
        }

        if ((doDeparture || doLeg2Departure) && flightCarrierAndNumberActual != '') {
            emailType = CourierLogisticsConfirmationEmailType.DepartureConfirmation;
        }

        if (doRecovered) {
            emailType = CourierLogisticsConfirmationEmailType.RecoveryConfirmation;
        }

        if (doDelivered) {
            emailType = CourierLogisticsConfirmationEmailType.DeliveryConfirmation;
        }

        this.props.showLoading('Saving logistic plans, one moment please...').then(() => {
            this.props.saveLogisticsData(logistics)
                .then(response => {
                    if (response.data.success) {
                        this.props.sendCourierEmail(chainId, clusterNumber, position, emailType)
                            .then(response => {
                                this.props.hideLoading();

                                if (response.data.success) {
                                    this.setState({
                                        logisticsEdit: {
                                            show: false,
                                            list: [],
                                            data: null,
                                            clusterId: 0
                                        }
                                    }, () => {
                                        this.getData(false);
                                    });
                                }
                            })
                            .catch((error: any) => {
                                this.props.hideLoading();
                                toast.error('Unable to send the confirmatiomn email...', {
                                    position: toast.POSITION.TOP_CENTER,
                                    autoClose: 3000
                                });
                            });;
                    }
                })
                .catch((error: any) => {
                    this.props.hideLoading();
                    toast.error('An error occurred while saving the logistics data...', {
                        position: toast.POSITION.TOP_CENTER,
                        autoClose: 3000
                    });
                });
        });
    }

    handleCancelLogistics = () => {
        this.setState({
            logisticsEdit: {
                show: false,
                list: [],
                data: null,
                clusterId: 0
            }
        });
    }

    handleSwitchToCustomLogistics = (positionNumber: number) => {
        // this.handleCancelLogistics();
        // this.handleEditCustomLogistics(positionNumber);
    }

    handleSwapViewChange = (view: any) => {
        this.setState({
            list: [],
            showSwaps: view,
            loading: true
        }, () => {
            return this.getData(false).then(() => {
                this.setState({
                    loading: false
                });
            });
        });
    }

    handleSwapViewChangeDropdown = (e: any) => {
        this.setState({
            showSwaps: e.target.value
        });
    }

    handleTimeZoneChangeDropdown = (e: any) => {
        this.setState({
            displayTimeZone: e.target.value
        });
    }

    handleTimeZoneChange = (tz: any) => {
        this.setState({
            displayTimeZone: tz
        });
    }

    handleDisplayChange = (e: FormEvent<HTMLSelectElement & FormControl>) => {
        this.props.changeDisplay(parseInt(e.currentTarget.value));
    }

    handleSaveNotes = (donorId: number, notes: string) => {
        return this.props.saveNotes(donorId, notes);
    }

    handleAcknowledgeAlert = (chainId: number, clusterNumber: number, positionNumber: number) => {
        if (this.props.isOps == false) {
            let swap = this.state.list.find(x => x.chainId == chainId && x.clusterNumber == clusterNumber && x.positionNumber == positionNumber);

            this.setState({
                alert: {
                    show: true,
                    data: _.cloneDeep(swap)
                }
            });
        }
    }

    handleAcknowledgeAlertSave = (chainId: number, clusterNumber: number, positionNumber: number, issueDescription: string, planDescription: string) => {
        this.setState({
            alert: {
                show: false,
                data: null
            }
        }, () => {
            this.props.showLoading("Saving fail-safe alert acknowledgement, one moment please...").then(() => {
                let request: IFailSafeAcknowledgeAlert = {
                    chainId,
                    clusterNumber,
                    positionNumber,
                    acknowledgedBy: 0,
                    issueDescription,
                    planDescription
                };

                this.props.failSafeAcknowledgeAlert(request).then(response => {
                    this.props.hideLoading();
                    this.refresh();
                });
            });
        });
    }

    handleAddressDownload = (donorCenterId: number, recipientCenterId: number, clusterId: number) => {
        this.props.showLoading("Downloading File...").then(() => {

            this.props.getCenterAddressesDownload(donorCenterId, recipientCenterId, clusterId).then((response: any) => {
                downloadFile(response.data, `logistics_address_list.rtf`, 'application/rtf');

                this.props.hideLoading();
            });

        });
    }


    handleContactsDownload = (clusterId: number) => {
        this.props.showLoading("Downloading File...").then(() => {

            this.props.getCenterContactsDownload(clusterId).then((response: any) => {
                downloadFile(response.data, `logistics_contacts_list.csv`, 'text/csv');
                this.props.hideLoading();
            });
        });
    }

    handleAcknowledgeAlertCancel = () => {
        this.setState({
            alert: {
                show: false,
                data: null
            }
        });
    }

    handleStartDateChange = (e: FormEvent<any>) => {
        this.setState({
            startDate: e.currentTarget.value
        });
    }

    handleEndDateChange = (e: FormEvent<any>) => {
        this.setState({
            endDate: e.currentTarget.value
        });
    }

    render = () => {
        const list = this.getList();
        const localTimeZone = moment.tz.zone(moment.tz.guess()).abbr(moment().milliseconds());
        const marginTop = this.props.app.display == DisplayType.NoMenuNoTabs ? 10 : 0;

        const showOptions = this.props.isOps == false ?
            [
                { id: 1, description: 'Menus/Tabs' },
                { id: 2, description: 'Menus Only' },
                { id: 3, description: 'Tabs Only' },
                { id: 4, description: 'No Menus/Tabs' }
            ]
            :
            [
                { id: 1, description: 'Menus' },
                { id: 4, description: 'No Menus' }
            ];

        return (
            <>
                <MediaQuery minWidth={1112}>
                    <div className='container-fluid'>
                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", height: 30, marginBottom: 20, marginTop }}>
                            <div style={{ flexBasis: "30%" }}>
                                {(this.props.app.display == DisplayType.NoMenuNoTabs || this.props.app.display == DisplayType.MenuOnly) && (
                                    <div style={{ fontSize: 28, fontWeight: 500, flexBasis: "33%" }}>MOVE TRACKER</div>
                                )}
                            </div>

                            <div style={{ flexBasis: "15%", textAlign: "center" }}>
                                {this.state.loading && (
                                    <div className="alert alert-info" style={{ marginBottom: 0, padding: 7.5, textAlign: "center" }}>Fetching {this.state.showSwaps == 'ALL' ? 'all' : 'in-process'} swaps...</div>
                                )}
                            </div>

                            <div style={{ flexBasis: "55%", display: "flex", justifyContent: "flex-end", alignItems: "center" }}>
                                <div style={{ display: "flex", alignItems: "center", marginRight: 5 }}>
                                    {this.state.showSwaps == 'ALL' && (
                                        <div style={{ display: 'flex', alignItems: 'center', marginRight: 5 }}>
                                            <div style={{ marginRight: 5, fontSize: 12 }}>Pickup Date:</div>
                                            <div>
                                                <InputGroup bsSize='sm'>
                                                    <MaskedInput
                                                        className='form-control input-sm'
                                                        style={{ borderRight: '0 none' }}
                                                        mask='11/11/1111'
                                                        name='startDate'
                                                        value={this.state.startDate}
                                                        onChange={this.handleStartDateChange}
                                                    />
                                                    <InputGroup.Addon>&nbsp;to&nbsp;</InputGroup.Addon>
                                                    <MaskedInput
                                                        className='form-control input-sm'
                                                        style={{ borderLeft: '0 none' }}
                                                        mask='11/11/1111'
                                                        name='endDate'
                                                        value={this.state.endDate}
                                                        onChange={this.handleEndDateChange}
                                                    />
                                                </InputGroup>
                                            </div>
                                        </div>
                                    )}

                                    <div style={{ marginRight: 5, fontSize: 12 }}>Swaps:</div>
                                    <div style={{ marginRight: 5 }}>
                                        <ToggleButtonGroup type="radio" name="swaps" value={this.state.showSwaps} onChange={this.handleSwapViewChange}>
                                            <ToggleButton type="radio" value={'ALL'} className={this.state.showSwaps == "ALL" ? "btn-primary btn-xs" : "btn-xs"}>All Swaps</ToggleButton>
                                            <ToggleButton type="radio" value={'TODAY'} className={this.state.showSwaps == "TODAY" ? "btn-primary btn-xs" : "btn-xs"}>Today's Swaps</ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>

                                    <div style={{ marginRight: 5, fontSize: 12 }}>Time&nbsp;zone:</div>
                                    <div>
                                        <ToggleButtonGroup type="radio" name="swaps" value={this.state.displayTimeZone} onChange={this.handleTimeZoneChange}>
                                            <ToggleButton type="radio" value={'DONORCENTER'} className={this.state.displayTimeZone == "DONORCENTER" ? "btn-primary btn-xs" : "btn-xs"}>Donor Center</ToggleButton>
                                            <ToggleButton type="radio" value={'YOUR'} className={this.state.displayTimeZone == "YOUR" ? "btn-primary btn-xs" : "btn-xs"}>Local</ToggleButton>
                                        </ToggleButtonGroup>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <MoveTrackerList
                            list={list}
                            displayType={this.props.app.display}
                            displayTimeZone={this.state.displayTimeZone}
                            isCourier={this.props.isCourier}
                            onSwitchPlan={this.handleSwitchPlan}
                            onViewLogistics={this.props.isCourier == false ? this.handleViewLogistics : this.handleEditLogistics}
                            onSaveNotes={this.handleSaveNotes}
                            onAcknowledgeAlert={this.handleAcknowledgeAlert}
                        />

                        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                            <div style={{ fontSize: 12 }}>
                                {list.length} swaps shown / {this.state.list.length} total swaps ...
                            </div>

                            <div style={{ fontSize: 12 }}>
                                * MST - No daylight savings
                            </div>

                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Show:</div>
                                <div style={{ marginRight: 10 }}>
                                    <FormControlWrapper
                                        value={this.props.app.display}
                                        componentClass="select"
                                        style={{ fontSize: 12 }}
                                        onChange={this.handleDisplayChange}
                                    >
                                        {showOptions.map(item =>
                                            <option value={item.id}>{item.description}</option>
                                        )}
                                    </FormControlWrapper>
                                </div>
                            </div>

                            <div style={{ display: "flex", alignItems: "center" }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Auto refresh:</div>
                                <div style={{ marginRight: 5 }}>
                                    <FormControlWrapper
                                        value={this.state.autoRefresh}
                                        componentClass="select"
                                        style={{ fontSize: 12 }}
                                        onChange={this.handleAutoRefreshChange}
                                    >
                                        {refreshIntervals.map((interval, index) =>
                                            <option key={index} value={interval.value}>{interval.label}</option>
                                        )}
                                    </FormControlWrapper>
                                </div>
                                <div>
                                    <Glyphicon glyph="refresh" title="Refresh now" onClick={this.handleRefresh} />
                                </div>
                            </div>
                        </div>
                    </div>
                </MediaQuery>

                <MediaQuery maxWidth={1111}>
                    <div style={{ marginBottom: 10, textAlign: "center" }}>
                        {list.length} swaps shown / {this.state.list.length} total swaps ...
                    </div>

                    <MediaQuery maxWidth={414}>
                        <div style={{ marginBottom: 10 }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 10, fontSize: 12 }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Swaps:</div>
                                <div>
                                    <FormControlWrapper
                                        componentClass="select"
                                        onChange={this.handleSwapViewChangeDropdown}
                                    >
                                        <option value="ALL">All Swaps</option>
                                        <option value="TODAY">Today's Swaps</option>
                                    </FormControlWrapper>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Time&nbsp;Zone:</div>
                                <FormControlWrapper
                                    componentClass="select"
                                    style={{ width: "initial" }}
                                    onChange={this.handleTimeZoneChangeDropdown}
                                >
                                    <option value="DONORCENTER">Donor Center</option>
                                    <option value="YOUR">Local</option>
                                </FormControlWrapper>
                            </div>
                        </div>
                    </MediaQuery>

                    <MediaQuery minWidth={415}>
                        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginBottom: 10 }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", marginRight: 10, fontSize: 12 }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Swaps:</div>
                                <div>
                                    <FormControlWrapper
                                        componentClass="select"
                                        onChange={this.handleSwapViewChangeDropdown}
                                    >
                                        <option value="ALL">All Swaps</option>
                                        <option value="TODAY">Today's Swaps</option>
                                    </FormControlWrapper>
                                </div>
                            </div>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
                                <div style={{ marginRight: 5, fontSize: 12 }}>Time&nbsp;Zone:</div>
                                <FormControlWrapper
                                    componentClass="select"
                                    style={{ width: "initial" }}
                                    onChange={this.handleTimeZoneChangeDropdown}
                                >
                                    <option value="DONORCENTER">Donor Center</option>
                                    <option value="YOUR">Local</option>
                                </FormControlWrapper>
                            </div>
                        </div>
                    </MediaQuery>

                    <div style={{ display: "flex", justifyContent: "center", marginBottom: 10 }}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ marginRight: 5, fontSize: 12 }}>Auto refresh:</div>
                            <div style={{ marginRight: 5 }}>
                                <FormControlWrapper
                                    value={this.state.autoRefresh}
                                    componentClass="select"
                                    onChange={this.handleAutoRefreshChange}
                                >
                                    {refreshIntervals.map((interval, index) =>
                                        <option key={index} value={interval.value}>{interval.label}</option>
                                    )}
                                </FormControlWrapper>
                            </div>
                            <div>
                                <Glyphicon glyph="refresh" title="Refresh now" onClick={this.handleRefresh} />
                            </div>
                        </div>
                    </div>

                    {this.state.loading && (
                        <div className="bg-info" style={{ marginBottom: 10, textAlign: "center", padding: 10 }}>Fetching in-process swaps...</div>
                    )}

                    <div className="container-fluid" style={{ marginTop: 5 }}>
                        {list.map((item, index) => {
                            return (
                                <MoveTrackerListCard
                                    key={index}
                                    item={item}
                                    useBackupPlan={item.activeLogisticsPlan == ActiveLogisticsPlan.Backup.toString()}
                                    displayTimeZone={this.state.displayTimeZone}
                                    localTimeZone={localTimeZone}
                                    isCourier={this.props.isCourier}
                                    onViewLogistics={this.props.isCourier == false ? this.handleViewLogistics : this.handleEditLogistics}
                                    onShowMap={this.handleShowMap}
                                    onShowGps={this.handleShowGps}
                                    onSwitchPlan={this.handleSwitchPlan}
                                    onSaveNote={this.handleSaveNotes}
                                    onAcknowledgeAlert={this.handleAcknowledgeAlert}
                                />
                            );
                        })}
                    </div>
                </MediaQuery>

                <LogisticsView
                    show={this.state.logistics.show}
                    data={this.state.logistics.data}
                    onClose={this.handleCloseLogistics}
                />

                <Logistics
                    show={this.state.logisticsEdit.show}
                    clusterId={this.state.logisticsEdit.clusterId}
                    data={this.state.logisticsEdit.data}
                    logisticsProviders={this.props.swaps.logisticsProviders}
                    transportTypes={this.props.swaps.transportTypeList}
                    logisticsList={this.state.logisticsEdit.list}
                    distanceBetweenCentersList={this.props.swaps.distanceBetweenCenters}
                    forCourier={true}
                    onSwitchToLogisticsPlan={this.handleSwitchToCustomLogistics}
                    onSave={this.props.isCourier ? this.handleSaveLogisticsForCourier : this.handleSaveLogistics}
                    onCancel={this.handleCancelLogistics}
                    onAddressesExport={this.handleAddressDownload}
                    onContactsExport={this.handleContactsDownload}
                />

                <AcknowledgeAlert
                    show={this.state.alert.show}
                    data={this.state.alert.data}
                    onSave={this.handleAcknowledgeAlertSave}
                    onCancel={this.handleAcknowledgeAlertCancel}
                />
            </>
        );
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app,
        swaps: state.swaps
    };
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return ({
        toggleLoading: (showLoading, message) => {
            return dispatch(AppActionCreators.toggleLoading(showLoading, message));
        },
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getSwapsInProcess: (isOps) => {
            return dispatch(SwapActionCreators.getSwapsInProcess(isOps));
        },
        getSwapsForMoveTracker: (isOps, centerId, clearCache) => {
            return dispatch(SwapActionCreators.getSwapsForMoveTracker(isOps, centerId, clearCache));
        },
        getLogisticsData: (donorId, recipientId) => {
            return dispatch(SwapActionCreators.getLogisticsDataByDonorRecipient(donorId, recipientId));
        },
        getLogisticsDataByChainCluster: (chainId, clusterNumber) => {
            return dispatch(SwapActionCreators.getLogisticsDataByChainCluster(chainId, clusterNumber));
        },
        getLookupData: () => {
            return dispatch(SwapActionCreators.getLookupData());
        },
        saveActiveLogisticsPlan: (donorId, ActiveLogisticsPlan) => {
            return dispatch(SwapActionCreators.saveActiveLogisticsPlan(donorId, ActiveLogisticsPlan));
        },
        saveNotes: (donorId, notes) => {
            return dispatch(SwapActionCreators.saveMoveTrackerNotes(donorId, notes));
        },
        failSafeAcknowledgeAlert: (request) => {
            return dispatch(SwapActionCreators.failSafeAcknowledgeAlert(request));
        },
        saveLogisticsData: (logistics) => {
            return dispatch(SwapActionCreators.saveLogisticsData(logistics));
        },
        changeDisplay: (display: number) => {
            dispatch(AppActionCreators.changeDisplay(display));
        },
        sendCourierEmail: (chainId, clusterNumber, positionMumber, emailType) => {
            return dispatch(SwapActionCreators.sendCourierEmail(chainId, clusterNumber, positionMumber, emailType));
        },
        getCenterAddressesDownload: (donorCenterId, recipCenterId, clusterId) => {
            return dispatch(CenterActionCreators.getCenterAddressesDownload(donorCenterId, recipCenterId, clusterId));
        },
        getCenterContactsDownload: (clusterId) => {
            return dispatch(ContactActionCreators.getContactResultsForLogistics(clusterId));
        }
    });
}

export default connect<{}, IDispatchProps, IOwnProps>(
    mapStateToProps,
    mapDispatchToProps)(MoveTrackerContainer);

